const rankingItems = [
  { rank: 1, title: '斗破苍穹', genre: '玄幻热血', status: '已完结', heat: '9.8' },
  { rank: 2, title: '完美世界', genre: '玄幻热血', status: '连载中', heat: '9.7' },
  { rank: 3, title: '一念永恒', genre: '修仙搞笑', status: '已完结', heat: '9.6' },
  { rank: 4, title: '全职高手', genre: '电竞热血', status: '已完结', heat: '9.5' },
  { rank: 5, title: '星辰变', genre: '修仙热血', status: '已完结', heat: '9.4' },
  { rank: 6, title: '武动乾坤', genre: '玄幻热血', status: '已完结', heat: '9.3' },
];

export default function SectionRanking() {
  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-white';
    if (rank === 2) return 'bg-secondary-400 text-white';
    if (rank === 3) return 'bg-secondary-600 text-white';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            人气榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            全网漫画完整版热度排行，下拉式阅读尽享全集
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${getRankBadge(item.rank)}`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.genre}
                  </span>
                  <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                    item.status === '已完结' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                  }`}>
                    {item.status}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
                <i className="ri-fire-fill text-sm"></i>
                <span className="text-sm font-bold">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}